var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('vuetify-logo')],1),_c('div',{staticClass:"slider-section"},[_c('verify',{attrs:{"auth":_vm.auth}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }